import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";

import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";

import FormControl from "@mui/material/FormControl";

import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import { addOrUpdateSteamHumidifyPoint } from "../../../actions/summerPointsActions";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

function AdiabaticHumidifing() {
  const [relativeHumidity, setRelativeHimidity] = useState();
  const [absoluteHumidity, setAbsoluteHumidity] = useState();
  const [newTemperature, setNewTemperature] = useState();
  const [coolingProccessVariable, setCoolingProcessVariable] = useState(10);
  const isFirstRender = useRef(true);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return; // Skip the first render
    }
    // dispatch(addOrUpdateAdiabaticHumidifyPoint(relativeHumidity));
  }, [relativeHumidity]);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Paper p={2}>
        <Grid
          container
          spacing={1}
          alignItems="center"
          justifyContent="space-evenly"
          direction="row"
        >
          <Grid item xs={5}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Parameter for calculation
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={coolingProccessVariable}
                label="Parameter for calculation"
                defaultValue={10}
                onChange={(event) => {
                  setCoolingProcessVariable(event.target.value);
                }}
              >
                <MenuItem value={10}>Relative humidity</MenuItem>
                <MenuItem value={20}>Absolute humidity</MenuItem>
                <MenuItem value={20}>Temperature</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={5}>
            {coolingProccessVariable === 10 && (
              <TextField
                label="Relative Humidity"
                id="outlined-start-adornment"
                name="relativeHumidity"
                //value={newTemperature}
                // sx={{ m: 1, width: "25ch" }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">%</InputAdornment>
                  ),
                }}
                onBlur={(event) => {
                  setRelativeHimidity(event.target.value);
                }}
              />
            )}
            {coolingProccessVariable === 20 && (
              <TextField
                label="Absolute Humidity"
                id="outlined-start-adornment"
                name="absoluteHumidity"
                value={absoluteHumidity}
                // sx={{ m: 1, width: "25ch" }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">%</InputAdornment>
                  ),
                }}
                onChange={(event) => {
                  setAbsoluteHumidity(event.target.value);
                }}
              />
            )}
            {coolingProccessVariable === 30 && (
              <TextField
                label="Temperature"
                id="outlined-start-adornment"
                name="temperature"
                value={newTemperature}
                // sx={{ m: 1, width: "25ch" }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">°C</InputAdornment>
                  ),
                }}
                onChange={(event) => {
                  setNewTemperature(event.target.value);
                }}
              />
            )}
          </Grid>
        </Grid>{" "}
      </Paper>{" "}
    </Box>
  );
}

export default AdiabaticHumidifing;
